import _ from 'lodash';

export interface GridLayoutGroupConfig {
  scene: Phaser.Scene;
  elements: (Phaser.GameObjects.Container | Phaser.GameObjects.Image)[];
  columns: number;
  hPadding: number;
  vPadding: number;
  hMargin?: number;
  vMargin?: number;
  backingElement?: Phaser.GameObjects.NineSlice | Phaser.GameObjects.Image;
  alignment?: 'LEFT' | 'CENTER';
}

export class GridLayoutGroup extends Phaser.GameObjects.Container {
  elements: (Phaser.GameObjects.Container | Phaser.GameObjects.Image)[];

  columns: number = 1; // Todo - let us set limit on columns OR rows.
  hPadding: number;
  vPadding: number;
  hMargin: number;
  vMargin: number;
  backingElement?: Phaser.GameObjects.NineSlice | Phaser.GameObjects.Image;
  alignment: 'LEFT' | 'CENTER';

  constructor(config: GridLayoutGroupConfig) {
    super(config.scene);
    this.elements = config.elements;
    this.columns = config.columns;
    this.hPadding = config.hPadding;
    this.vPadding = config.vPadding;
    this.hMargin = config.hMargin || 0;
    this.vMargin = config.vMargin || 0;
    this.backingElement = config.backingElement;
    this.alignment = config.alignment || 'LEFT';

    this.setPosition(this.hMargin, this.vMargin);

    for (let e in this.elements) {
      const element = this.elements[e];
      this.add(element);
    }

    this.updateLayout();
  }

  updateLayout() {
    // for (var y = 0; y < this.elements.length / this.columns; y++) {
    //   const startIndex = y * this.columns;
    //   const endIndex = startIndex + this.columns;
    //   const elementsInRow = this.elements.slice(startIndex, endIndex);
    //   AlignElementsLeft(
    //     elementsInRow,
    //     { x: this.x, y: this.y + y * this.vPadding },
    //     this.hPadding,
    //   );
    //   // for (var x = 0; x < this.columns; x++) {
    //   //   const element = this.elements[i];
    //   //   if (!element) continue;
    //   //   element.setPosition(x * this.hPadding, y * this.vPadding);
    //   //   i++;
    //   // }
    // }
    let i = 0;
    let nextX = 0;
    let nextY = 0;

    for (var y = 0; y < this.elements.length / this.columns; y++) {
      for (var x = 0; x < this.columns; x++) {
        const element = this.elements[i];
        if (!element) {
          continue;
        }
        element.setPosition(nextX * this.hPadding, nextY * this.vPadding);
        i++;
        if (element.visible) {
          nextX++;
          if (x === this.columns - 1) {
            nextY++;
            nextX = 0;
          }
        }
      }
    }
  }

  addItem(item: Phaser.GameObjects.Image | Phaser.GameObjects.Container) {
    this.add(item);
    this.elements.push(item);
    this.updateLayout();
  }

  clear() {
    for (let i in this.elements) {
      this.elements[i].destroy();
    }
    this.elements = [];
  }

  getHeight() {
    const rows = this.elements.length / this.columns;
    return _.max([
      (this.backingElement?.height || 0) / 2,
      rows * this.vPadding +
        this.vMargin * 2 -
        (this.backingElement?.height || 0) +
        64,
    ]);
  }
}
